import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import React from 'react';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import {
  ScenarioSelectionRedefinedPreviewScenarios,
} from './ScenarioSelectionRedefinedPreviewScenarios';

export const ScenarioSelectionRedefinedPreviewScenariosContainer = ({ onAgentReview, onSelectSuccess }) => {
  return (
    <SelectScenarioContextProvider onAgentReview={onAgentReview} onSelectSuccess={onSelectSuccess}>
      <ScenarioSelectionRedefinedPreviewScenarios />
    </SelectScenarioContextProvider>
  );
};

ScenarioSelectionRedefinedPreviewScenariosContainer.defaultProps = {
  onAgentReview: noop,
};

ScenarioSelectionRedefinedPreviewScenariosContainer.propTypes = {
  onAgentReview: PropTypes.func,
  onSelectSuccess: PropTypes.func.isRequired,
};
